/*! *********************************************************************
 *
 * Copyright 2021 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *************************************************************************
 */
var STORAGE_LANG_CONSTANT = 'i18nLng';
/**
 * Get preferred language from Storage
 */
var StorageLanguageDetector = /** @class */ (function () {
    function StorageLanguageDetector() {
    }
    StorageLanguageDetector.prototype.detect = function () {
        var found = [];
        try {
            var value = window.localStorage.getItem(STORAGE_LANG_CONSTANT);
            if (typeof value === 'string') {
                found.push(value);
            }
        }
        catch (e) {
            console.error(e);
        }
        return found;
    };
    /**
     * Set preferred language from Storage
     * @param {string} lang
     */
    StorageLanguageDetector.prototype.store = function (lang) {
        try {
            window.localStorage.setItem(STORAGE_LANG_CONSTANT, lang);
        }
        catch (e) {
            console.error(e);
        }
    };
    return StorageLanguageDetector;
}());
export default StorageLanguageDetector;
